module.exports = __webpack_public_path__ + "media/images/favicon-16x16-b9b15f4c0adc740c5cf919b0cdcf20af.png";